import React, { useEffect, useState } from 'react';
import API from '../api';
import CustomerForm from './CustomerForm';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

function Customers() {
  const [customers, setCustomers] = useState([]); // displayed (latest 10 & filtered)
  const [allCustomers, setAllCustomers] = useState([]); // full fetched list
  const [filterText, setFilterText] = useState('');
  const [editing, setEditing] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };
  const fetchCustomers = async () => {
    try {
      const res = await API.get('customers/');
      const list = Array.isArray(res.data) ? res.data : [];
      // sort by created_at desc if available, else by id desc
      list.sort((a,b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : (a.id || 0);
        const tb = b.created_at ? new Date(b.created_at).getTime() : (b.id || 0);
        return tb - ta;
      });
      setAllCustomers(list);
      // show latest 10
      setCustomers(list.slice(0,10));
    } catch (e) {
      setAllCustomers([]);
      setCustomers([]);
    }
  };

  const applyFilter = (text) => {
    const t = (text || '').toLowerCase();
    const filtered = allCustomers.filter(c => {
      return (`${c.name} ${c.phone} ${c.email || ''} ${c.customer_code || ''}`.toLowerCase().indexOf(t) !== -1);
    });
    setCustomers(filtered.slice(0,10));
  }

  useEffect(() => { fetchCustomers(); }, []);
  useEffect(() => applyFilter(filterText), [filterText, allCustomers]);

  const handleDelete = (id) => {
    API.delete(`customers/${id}/`).then(fetchCustomers);
  };

  const handleEdit = (customer) => {
    setEditing(customer);
  };

  const handleFormSubmit = () => {
    setEditing(null);
    fetchCustomers();
  };

  return (
    <div className="page-container">
                <div className="login-buttons">
                    <button onClick={() => navigate('/')}>🏠 {t('Home')}</button>
                    <button onClick={handleLogout}>🚪 {t('Logout')}</button>
                </div>    
                      <h2>{t('Customers')}</h2>


      <CustomerForm customer={editing} onSubmit={handleFormSubmit} />
                    <input
          type="search"
          placeholder={t('Search...')}
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          style={{width: '100%', padding: '8px', marginBottom: 8}}
        />
              <div style={{marginBottom:12}}>

  <div style={{fontSize:12, color:'#666'}}>{t('Showing latest')} {customers.length} {t('customers')}</div>
      </div>
      <ul>
        {customers.map(c => (
          <li key={c.id}>
            {c.name} ({c.phone}) 
            <button onClick={() => handleEdit(c)}>{t('Edit')}</button>
            <button onClick={() => handleDelete(c.id)}>{t('Delete')}</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Customers;
